import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/useAuth';
import { peutOuvrirDossierOrganisation } from '../../lib/droits-repertoire';

/**
 * Nom d'une entreprise ou d'un partenaire menant à son dossier
 * (`/ped-repertoire/:id`) — ou simple texte pour qui ne peut pas l'ouvrir
 * (TF-467 : le pôle pédagogique garde le matching et les immersions, pas le
 * répertoire). `classeLien` ne s'applique qu'au lien : un texte qui change de
 * couleur au survol se prendrait pour un lien.
 */
export function LienOrganisation({
  id,
  nom,
  className = '',
  classeLien,
}: {
  id: string;
  nom: string;
  className?: string;
  classeLien: string;
}): JSX.Element {
  const { peutAcceder } = useAuth();
  if (!peutOuvrirDossierOrganisation(peutAcceder)) {
    return <span className={className || undefined}>{nom}</span>;
  }
  return (
    <Link to={`/ped-repertoire/${id}`} className={`${className} ${classeLien}`.trim()}>
      {nom}
    </Link>
  );
}
